import {defineRecipe} from '@chakra-ui/react3'

/**
 * Full-bleed wrapper for the promotional message bar.
 *
 * Spans the viewport width and sits in normal document flow at the very top of
 * the page (above the header), so it scrolls away as the user scrolls down. The
 * inner content is width-constrained separately via `layerStyle="container.page"`.
 *
 * The legacy CMS stylesheet caps `.sk-content-column` at `1546px`; that cap is
 * neutralised here because the leap page container already constrains the width.
 */
const messageBarRecipe = defineRecipe({
    base: {
        width: 'full',
        position: 'relative',
        bg: 'primary.base.black',

        // Override the legacy CMS template: its stylesheet caps
        // `.sk-content-column` at a fixed max-width, which is neutralised here so
        // the content fits the leap page container (constrained separately via
        // `layerStyle="container.page"`) instead of the legacy cap.
        '& .sk-content-column': {
            maxWidth: 'none'
        }
    }
})

export default messageBarRecipe
